import PropTypes from 'prop-types'

function ListingListItem({
  image,
  title,
  categories,
  directions_url,
  website,
  has_address,
  street_address,
  city,
  state,
  zip,
  phone,
  phone_url,
  email,
}) {
  const hasCtas = directions_url || website
  const hasContact = phone || email

  return (
    <div className="w-full md:flex">
      <div className="flex-shrink-0 border md:w-1/3 lg:w-96">
        <img src={image} alt={title} className="object-cover w-full h-full" />
      </div>

      <div className="items-center w-full p-6 bg-white border border-t-0 md:border-t md:border-l-0 md:flex-1 md:flex lg:p-8 xl:px-16">
        <div className="w-full md:flex">
          <div className="md:w-1/2 xl:w-3/5">
            <h2 className="font-serif text-xl text-brand-blue lg:text-2xl">{title}</h2>

            <div className="mt-1 text-sm lg:text-base">{categories}</div>

            {hasCtas && (
              <div className="flex mt-8 space-x-2 xl:mt-12">
                {directions_url && (
                  <a
                    href={directions_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-auto px-3 text-xs btn btn-hollow xl:text-sm xl:px-5"
                  >
                    Directions
                  </a>
                )}

                {website && (
                  <a
                    href={website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-auto px-3 text-xs btn btn-fill xl:text-sm xl:px-5"
                  >
                    Details
                  </a>
                )}
              </div>
            )}
          </div>

          {(has_address || hasContact) && (
            <div className="mt-8 text-sm space-y-4 md:mt-1 md:w-1/2 md:pl-6 lg:text-base xl:w-2/5">
              {has_address && (
                <div className="flex items-start">
                  <svg viewBox="0 0 18 23" className="flex-shrink-0 w-4 mr-3">
                    <g stroke="#ABABAB" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M16.664 8.581a8.082 8.082 0 00-16.164 0c0 6.242 8.082 13.787 8.082 13.787s8.082-7.545 8.082-13.787z" />
                      <path d="M12.623 8.581a4.04 4.04 0 10-8.081.001 4.04 4.04 0 008.08 0z" />
                    </g>
                  </svg>

                  <div>
                    {street_address}
                    <br />
                    {city}, {state} {zip}
                  </div>
                </div>
              )}

              {hasContact && (
                <div className="flex items-start">
                  <svg viewBox="0 0 18 21" className="flex-shrink-0 w-4 mr-3">
                    <path
                      d="M17.08 17.394c-.538 1.943-2.602 3.212-4.614 2.837-8.042-1.5-12.818-9.01-10.668-16.776C2.336 1.513 4.401.243 6.412.618a3.62 3.62 0 01.679.195.794.794 0 01.512.825l-.527 5.398a.32.32 0 01-.242.27s-.994.244-1.483.369c-.151.038-.256.177-.241.321a9.714 9.714 0 001.463 4.19 9.91 9.91 0 003.18 3.12.32.32 0 00.397-.068c.333-.373 1-1.148 1-1.148.088-.1.23-.138.35-.093l5.168 1.897a.796.796 0 01.531.815 3.543 3.543 0 01-.12.685z"
                      stroke="#ABABAB"
                      fill="none"
                      fillRule="evenodd"
                    />
                  </svg>

                  <div>
                    {phone && (
                      <div>
                        <a href={phone_url} className="hover:text-brand-green transition-colors">
                          {phone}
                        </a>
                      </div>
                    )}
                    {email && (
                      <div>
                        <a href={`mailto:${email}`} className="hover:text-brand-green transition-colors">
                          {email}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

ListingListItem.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  categories: PropTypes.string,
  directions_url: PropTypes.string,
  website: PropTypes.string,
  has_address: PropTypes.bool,
  street_address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  phone: PropTypes.string,
  phone_url: PropTypes.string,
  email: PropTypes.string,
}

export default ListingListItem
